import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
import mediaQueries from "../../../util/mediaqueries";
import { spacing } from "../../../util/spacing";
import { typography } from "../../../util/styles-mixins";
import styled, { css } from 'styled-components';
import Text, { SIZE } from "../../typography/text/next";
import { Eyebrow } from "../../typography";
import { ImageWithLazyAttributes } from "../../images";
export var Image = styled(ImageWithLazyAttributes).withConfig({
  componentId: "sc-1yhulnx-0"
})(["width:100%;height:auto;"]);
export var Container = styled.div.withConfig({
  componentId: "sc-1yhulnx-1"
})(["", " ", " ", ""], mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "]))))), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n  "]))))), function (_ref) {
  var as = _ref.as;
  return as === 'a' && css(["", "{transition:transform 200ms ease-in-out;}&:hover{", "{transform:scale(1.1);}}"], Image, Image);
});
export var ImageContainer = styled.div.withConfig({
  componentId: "sc-1yhulnx-2"
})(["line-height:0;margin-bottom:", ";overflow:hidden;", " ", ""], spacing(4), mediaQueries.sm(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex: 0 0 50%;\n    margin-bottom: 0;\n  "]))))), mediaQueries.md(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n  "])), 0)), spacing(4)));
export var Title = styled(Text).attrs(function () {
  return {
    size: SIZE.M,
    largeViewportsSize: SIZE.L,
    extraLargeViewportsSize: SIZE.L,
    emphasised: true
  };
}).withConfig({
  componentId: "sc-1yhulnx-3"
})(["", " &:not(:last-child){margin-bottom:", ";}"], typography.lineClamp(3), spacing(1));
export var Description = styled(Text).attrs(function () {
  return {
    size: SIZE.S,
    extraLargeViewportsSize: SIZE.M
  };
}).withConfig({
  componentId: "sc-1yhulnx-4"
})(["", " &:not(:last-child){margin-bottom:", ";}"], typography.lineClamp(4), spacing(1));
export var Link = styled(Text).attrs(function () {
  return {
    size: SIZE.S,
    extraLargeViewportsSize: SIZE.M,
    emphasised: true,
    underlined: true
  };
}).withConfig({
  componentId: "sc-1yhulnx-5"
})(["margin-top:", ";"], spacing(2));
export var ContentContainer = styled.div.withConfig({
  componentId: "sc-1yhulnx-6"
})(["", "{margin-bottom:", ";}", " ", ""], Eyebrow, spacing(2), mediaQueries.sm(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    flex: 0 0 50%;\n    padding: ", ";\n  "])), 0)), spacing(0, 3)), mediaQueries.md(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: 0;\n  "]))))));